import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const PracticeInfo = () => {
  const practice = useSelector((s: RootState) => s.auth.practice);
  if (!practice) return null;
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h2 className="text-2xl font-semibold text-gray-900">{practice.title}</h2>
      {practice.address && (
        <p className="text-gray-600 mt-1">{practice.address}</p>
      )}
    </div>
  );
};




